"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fagnano-olona": {
    "f10d1001": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "baraggioli": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16b4f2e4": [{
      "hkey": "e668995f",
      "slug": "fagnano-olona-bergoro",
      "name": "Fagnano Olona-Bergoro",
      "primary": true,
      "skipSearch": false
    }],
    "bergoro": [{
      "hkey": "e668995f",
      "slug": "fagnano-olona-bergoro",
      "name": "Fagnano Olona-Bergoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7ab37051": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "castellazzo": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d557a5bb": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c155cbc": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "dafc5928",
      "slug": "fagnano-olona",
      "name": "Fagnano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;